"use client";

import dynamic from "next/dynamic";

export const TranscriptionWrapper = dynamic(() => import("./Transcription").then(mod => mod.Transcription));
